/*
 * customsirge_sub_features.js
 * Injects the theme's configurable "subscription perk" row (icon + text items,
 * authored as `subscription_feature` blocks) into the Kaching subscribe card.
 *
 * The Kaching subscriptions widget is an app-rendered block whose internal DOM
 * the theme can't author, and it loads / re-renders asynchronously. The perks
 * live in a hidden <template> (rendered by the section); this script clones them
 * into the target element (a CSS selector from the section setting, e.g.
 * `.kaching-subscriptions__with-explanation`) once it appears, re-injects if the
 * widget re-renders, and falls back to the bottom of the subscriptions block if
 * the target never shows.
 */
(function () {
  var FALLBACK_MS = 8000;

  function init() {
    var tmpl = document.querySelector('template[data-customsirge-sub-features]');
    if (!tmpl) return;

    var selector = (tmpl.getAttribute('data-target') || '').trim();
    var usedFallback = false;

    function place(el) {
      if (!el || el.querySelector('.customsirge-sub-features')) return; // avoid duplicates
      el.appendChild(tmpl.content.cloneNode(true));
    }

    // Primary: inject into the target selector wherever it renders in the document.
    function inject() {
      if (usedFallback || !selector) return;
      place(document.querySelector(selector));
    }

    inject();

    // Re-check on any DOM change (widget loads late / re-renders on variant change),
    // debounced to once per frame. Kept running so a wiped card gets re-injected.
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        inject();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Safety net: if the target never appears (blank / wrong selector, widget not
    // present), show the perks at the bottom of the subscriptions block so they're
    // never lost.
    setTimeout(function () {
      if (document.querySelector('.customsirge-sub-features')) return;
      usedFallback = true;
      var host =
        document.querySelector('.customsirge-main-product__app-block') ||
        document.querySelector('.customsirge-main-product__info');
      place(host);
    }, FALLBACK_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
